// check the value o/p true or false
export const isValidValue = (val) =>
  val !== null &&
  val !== undefined &&
  val !== 'null' &&
  val !== 'undefined' &&
  val.toString().trim() !== '';

// check the value and return if it true
export const normalizeValue = (val, byDefaultValue = '') =>
  val !== null && val !== undefined && val !== 'null' && val !== 'undefined' ? val : byDefaultValue;

// format to yyyy-mm-dd format
export const formatToYYYYMMDD = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return ''; // Use Number.isNaN instead of global isNaN
  return d.toISOString().split('T')[0];
};

// utils/transformOptions.js
export const transformToSelectOptions = (data = [], labelKey = 'label', valueKey = 'value') => {
  if (!Array.isArray(data)) return [];
  return data?.map((item) => ({
    label: item[labelKey] ?? 'N/A',
    value: item[valueKey] ?? ''
  }));
};

// utils/CommonFunction.js
export const debounceFunction = (func, delay = 400) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const yesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

export const truncateText = (text, maxLength = 15, suffix = '...') => {
  if (!text) return '';
  const str = text.toString().trim();
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength) + suffix;
};

export const formatDateToDDMMYYYY = (dateStr) => {
  if (!dateStr) return '';
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) return dateStr;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [yyyy, mm, dd] = dateStr.split('-');
    return `${dd}-${mm}-${yyyy}`;
  }
  return dateStr;
};

export const formatDateToYYYYMMDD = (dateStr) => {
  if (!dateStr) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [dd, mm, yyyy] = dateStr.split('-');
    return `${yyyy}-${mm}-${dd}`;
  }
  return dateStr;
};
